// client/src/services/ratingService.js
import axios from '../utils/axiosConfig';

export const submitRating = (data) => axios.post('/ratings', data).then(r => r.data.rating);
export const getTherapistRatings = (therapistId) =>
  axios.get(`/ratings/therapist/${therapistId}`).then(r => r.data.ratings);
